import { Navigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import useAuthentication from "../hooks/useAuthentication";
import { frontendRoutes } from "../utility/frontendRoutes";

const AdminRoute = ({ children }) => {
  const { currentUser, isLoggedIn, isLoggingIn, isInitializing } =
    useAuthentication();
  const location = useLocation();

  if (isInitializing || isLoggingIn) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress size={32} />
      </Box>
    );
  }
  if (!isLoggedIn) {
    return (
      <Navigate to={frontendRoutes.LOGIN} state={{ from: location }} replace />
    );
  }
  if (!currentUser?.roles?.includes("admin")) {
    return <Navigate to={frontendRoutes.HOME} replace />;
  }
  return children;
};

export default AdminRoute;
